"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localText = void 0;
exports.localText = {
    copyToClipboard: 'Copy to clipboard',
    copiedToClipboard: 'Copied to clipboard',
};
